import React from "react";

const DirectorDesk = () => {
    return (
        <div id="director" className="about-message container">

            <div className="message-left">
                <img
                    src="https://picsum.photos/300/350"
                    alt="Director"
                />
            </div>

            <div className="message-right">

                <h2>DIRECTOR’S DESK</h2>

                <h4>A Message from the Director</h4><br />

                <p>
                    It gives me immense pleasure to welcome you to Nav Jeevan
                    Mission School, Anandnagar.
                </p>

                <p>
                    Education is not merely the acquisition of knowledge; it is
                    the process of shaping character, developing values and
                    preparing young minds to face the challenges of life with
                    confidence and responsibility. At Nav Jeevan Mission School,
                    we believe that every child is unique, gifted and capable
                    of achieving excellence when provided with the right
                    guidance, opportunities and encouragement.
                </p>

                <p>
                    Our endeavour is to provide a safe, nurturing and
                    stimulating learning environment where students can develop
                    academically, physically, emotionally, socially and
                    morally. We give equal importance to academic excellence,
                    discipline, character formation, creativity, leadership,
                    sports and co-curricular activities.
                </p>

                <p>
                    We are committed to equipping our students with the
                    knowledge, skills, values and confidence required to become
                    responsible citizens and compassionate human beings. With
                    the dedicated efforts of our teachers, the cooperation of
                    parents and the active participation of our students, we
                    continue to strive for excellence in every sphere.
                </p>

                <p>
                    I sincerely appreciate the commitment and dedication of our
                    teachers and staff, and I thank parents for their continued
                    trust and cooperation. Together, let us work towards
                    creating a bright and meaningful future for every child.
                </p>

                <p>
                    May our students grow in wisdom, knowledge, character and
                    compassion, and become a blessing to society and the nation.
                </p>

                <h4>With warm regards,
                    <br />
                    Director
                    <br />
                    Nav Jeevan Mission School
                    Anandnagar
                </h4>

            </div>

        </div>
    );
};

export default DirectorDesk;